<template>
  <b-button class="mt-3" variant="outline-secondary" @click="goBack">
    <i class="icon-arrow-left mr-1"></i>
    {{ $t('other.return') }}
  </b-button>
</template>

<script>
export default {
  name: "ProjectBackButton",
  methods: {
    goBack() {
      const historyIndex =
        this.$router.history && this.$router.history.index;
      if (historyIndex > 0) {
        this.$router.go(-1);
        return;
      }
      const projectId = this.$route.params.projectId;
      this.$router.push(
        projectId ? `/project/view/${projectId}` : "/projects"
      );
    }
  }
};
</script>
